// extracted by mini-css-extract-plugin
module.exports = {"editObservation":"EditObservationForm_editObservation__2gyVX","switch":"EditObservationForm_switch__3qO4D","status":"EditObservationForm_status__2h-l9"};